import ComparisonPage, { CompetitorData } from "@/components/marketing/ComparisonPage";

const competitor: CompetitorData = {
  name: "MyLOCALINA",
  slug: "mylocalina",
  type: "Solution locale suisse",
  hasCommissionPerCover: "variable",
  hasPriceCeiling: false,
  complexity: "moyenne",
  targetAudience: "Restaurants multi-sites ou groupes",
  focus: "Gestion + CRM",
  supportLanguage: "Allemand, Français",
  commissionPerCoverChf: "À confirmer selon la formule",
  countryOfOrigin: "Suisse (région Zoug)",
  websiteUrl: "https://www.mylocalina.ch",
  whenToChoose: [
    "Tu gères un groupe de plusieurs établissements avec des besoins de CRM avancés",
    "Tu recherches des fonctionnalités de marketing intégrées",
    "Tu as besoin d'intégrations POS spécifiques",
    "Tu es en Suisse alémanique et préfères un support germanophone natif",
    "Tu acceptes une mise en place plus complexe",
  ],
  pricingDescription:
    "MyLOCALINA propose différentes formules d'abonnement selon les fonctionnalités et la taille de l'établissement. Les tarifs ne sont pas publiés publiquement : ils sont établis sur devis selon les modules choisis (CRM, intégrations POS, multi-sites). Contactez directement MyLOCALINA pour une offre personnalisée.",
  conclusionStrength:
    "une solution suisse avec des fonctionnalités CRM avancées et un écosystème plus large",
  // 241 imp / 0 click sur 28j (GSC) → CTR 0% malgré une bonne position. Title
  // refondu pour une promesse concrète + lever l'incertitude prix de MyLOCALINA.
  seoTitle: "MyLOCALINA vs Piktable : tarifs cachés ou forfait clair ?",
  seoDescription: "MyLOCALINA ne publie pas ses prix, Piktable affiche un forfait fixe sans commission. Comparatif complet : tarifs, CRM, multi-sites, support FR/CH. Lequel choisir pour ton restaurant suisse ?",
};

const PiktableVsMyLocalina = () => {
  return <ComparisonPage competitor={competitor} />;
};

export default PiktableVsMyLocalina;
